module.exports = __webpack_public_path__ + "img/polygon-location.fc90d9a4.svg";